export const LOCATION_SNAPSHOT_ADD_ITEM_STEPS = Object.freeze({
  CHOICE: "choice",
  NEW: "new",
  SEARCH: "search",
  SEARCH_RESULTS: "search-results",
});

const { CHOICE, NEW, SEARCH, SEARCH_RESULTS } = LOCATION_SNAPSHOT_ADD_ITEM_STEPS;

export const LOCATION_SNAPSHOT_ADD_ITEM_STEP_META = Object.freeze({
  [CHOICE]: { step: 0, steps: 3 },
  [NEW]: { step: 1, steps: 2 },
  [SEARCH]: { step: 1, steps: 3 },
  [SEARCH_RESULTS]: { step: 2, steps: 3 },
});

export const getLocationSnapshotAddItemStepMeta = step =>
  LOCATION_SNAPSHOT_ADD_ITEM_STEP_META[step] || LOCATION_SNAPSHOT_ADD_ITEM_STEP_META[CHOICE];
